import { BRAND_LABEL } from '@moonpig/web-core-brand/config'
import { STORES } from '@moonpig/web-core-brand/config/moonpig'
import { GuidedNBATile } from './types'
import {
  ViewItemListEvent,
  ZodSelectItemEvent,
} from '@moonpig/web-core-analytics'
import { currencyCode } from '@moonpig/web-shared-products'

export const createViewItemListGAEvent = ({
  items,
  title,
  storeId,
}: {
  items: GuidedNBATile[]
  title: string
  storeId: string
}): ViewItemListEvent => {
  return {
    event: 'view_item_list',
    ecommerce: {
      items: items.map((item, index) => ({
        index: index + 1,
        item_brand: BRAND_LABEL.toLowerCase(),
        item_list_name: `guided nbas | ${title.toLowerCase()} | carousel`,
        item_name: item.title.toLowerCase(),
        quantity: 1,
        item_id: item.title.toLowerCase().replace(/[^a-z0-9-]/g, ''),
        price: 0,
      })),
      value: 0,
      currency: currencyCode(
        STORES.find(store => store.id === storeId)?.locale
          .currencyCode as string,
      ),
    },
    event_data: {
      action: 'view item list',
      category: 'product action',
      label: `guided nbas | ${title.toLowerCase()} | carousel`,
      non_interaction: true,
    },
  }
}

export const createSelectItemEvent = ({
  tile,
  index,
  title,
  items,
  storeId,
}: {
  tile: GuidedNBATile
  index: number
  title: string
  items: GuidedNBATile[]
  storeId: string
}): ZodSelectItemEvent => {
  const listName = `guided nbas | ${title.toLowerCase()} | carousel`
  const label = `${listName} | ${index + 1}/${items.length} | ${tile.title.toLowerCase()}`
  return {
    event: 'select_item',
    ecommerce: {
      items: [
        {
          index: index + 1,
          item_brand: BRAND_LABEL.toLowerCase(),
          item_list_name: listName,
          item_name: tile.title.toLowerCase(),
          quantity: 1,
          price: 0,
          item_id: tile.title.toLowerCase().replace(/[^a-z0-9-]/g, ''),
        },
      ],
      value: 0,
      currency: currencyCode(
        STORES.find(store => store.id === storeId)?.locale
          .currencyCode as string,
      ),
    },
    event_data: {
      action: 'select item',
      category: 'product action',
      label: label,
      non_interaction: true,
    },
  }
}
